import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("ascend_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ascend_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ascend_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (username, email, password) => {
    const ref_code = localStorage.getItem("ascend_ref") || undefined;
    const { data } = await api.post("/auth/register", { username, email, password, ref_code });
    localStorage.setItem("ascend_token", data.token);
    localStorage.removeItem("ascend_ref");
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ascend_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
